export const PROJECT_DETAILS = {
  "golden-goose": {
    title: "Golden Goose — Sneaker Narratives",
    category: "Product naming & campaign · 2023 — Present",
    intro:
      "Naming and storytelling for luxury sneaker launches, collaborations, and seasonal campaigns. Each piece written to feel like a memory — designed to last beyond the launch moment.",
    sections: [
      {
        heading: "Build on Dreams — Marathon",
        copy:
          "Ready, set, keep steady. This sneaker is the strength that lies beneath you. Designed to keep you grounded as you run after your dreams, it brings you closer to the track right under your feet. It's a reminder that every step counts. No matter how big or small, they're all meaningful. Inspired by the Golden Era of running.",
        images: ["/portfolio/image15.png", "/portfolio/image20.png"],
      },
      {
        heading: "Super-Star — Icon & Timelessness",
        copy:
          "True to its spirit, this design is a reminder of what it means to stay authentic. It holds the quiet strength of something timeless — the kind of icon that grows with you rather than fades away. It's about memory and belonging, the feeling of carrying a piece of yourself with every step you take.",
        images: ["/portfolio/image16.png", "/portfolio/image14.png"],
      },
      {
        heading: "Super-Star in Red Suede",
        copy:
          "Roses are red, and so are these Super-Stars. Red suede, silver glitter, and timeless style. These Super-Stars are an iconic love letter to your wardrobe — shimmering with heartfelt moments and dreamed up for stolen glances. These red-hot kicks are sure to spark fly.",
        images: ["/portfolio/image10.png", "/portfolio/image1.png"],
      },
    ],
  },
  "pitti-immagine": {
    title: "Pitti Immagine — International Communications",
    category: "Press & editorial · 2021 — Present",
    intro:
      "Editorial direction and press adaptation across Pitti Uomo, Pitti Filati, Taste, and Danzainfiera — translating Italian fashion's biggest stage for international audiences.",
    sections: [
      {
        heading: "The Pitti Pool — Edizione 110",
        copy:
          "The Pool: the inspirational and visual theme of the summer 2026 edition. A campaign about leisure, ritual, and the slow Italian way of dressing for the warmer months — rolled out across press, digital, and on-site at Fortezza da Basso.",
        images: ["/portfolio/pitti-pool.jpg", "/portfolio/pitti-pool-2.jpg"],
      },
      {
        heading: "Selected Press Releases",
        copy:
          "A small selection of Pitti Uomo press communications adapted for the international press circuit — covering guest designers, special guests, and partner showcases.",
        links: [
          {
            label: "Simone Rocha — Guest Designer",
            href: "https://uomo.pittimmagine.com/en/news/simone-rocha-guest-designer",
          },
          {
            label: "JiyongKim — Special Guest, Pitti Uomo 110",
            href: "https://uomo.pittimmagine.com/en/news/pitti-uomo-110-special-guest-JiyongKim",
          },
          {
            label: "Promas & DEFI — French Menswear at Pitti Uomo 109",
            href: "https://www.pittimmagine.com/en/pittimmagine/archive/uomo109/news/pitti-uomo-109-promas-e-defi",
          },
          {
            label: "Simone Rocha — Guest Designer (Italian)",
            href: "https://uomo.pittimmagine.com/it/news/simone-rocha-guest-designer",
          },
        ],
      },
    ],
  },
  "woolrich-manteco": {
    title: "Woolrich × Manteco — Heritage Repositioning",
    category: "Tone of voice & long-form copy · 2022 — 2024",
    intro:
      "Brand narrative and landing-page storytelling for a heritage outerwear collaboration — sustainable Italian wool, recycled military fibers, and a contemporary global audience.",
    sections: [
      {
        heading: "About the Collaboration",
        copy:
          "Crafted from a shared heritage and a commitment to the future. This collaboration draws from decades of expertise in sustainable fabric innovation — using recycled military fibers re-spun into fine Italian wool, all achieved through chemical-free processes. It's the union of legacy and progress: a quiet conversation between two houses that have spent generations refining what it means to make something well.",
        images: ["/portfolio/image21.png", "/portfolio/image22.png"],
      },
      {
        heading: "A Sustainable Approach",
        copy:
          "Research and tradition. The Manteco edition is rooted in a sustainable approach: dormant stocks, upcycled fibers, and the kind of slow craftsmanship that outerwear deserves. The landing page tells that story with the patience the cloth itself requires.",
        images: ["/portfolio/image19.png"],
      },
    ],
  },
  "lvr-sustainable": {
    title: "LuisaViaRoma — LVRSustainable",
    category: "Long-form editorial · 2020 — 2023",
    intro:
      "Editor and content lead at LuisaViaRoma — and one of the editorial voices that shaped LVRSustainable from day one. Long-form interviews with designers reshaping luxury through sustainability.",
    sections: [
      {
        heading: "Gabriela Hearst — In Conversation",
        copy:
          "On day 18 of lockdown, Gabriela Hearst shed light on how to keep moving forward, how to incorporate sustainability practices into our everyday lives, and how CEOs and creative directors might shape the future. A conversation with the trailblazing designer amidst changing times, 2021.",
        images: [
          "/portfolio/image9.png",
          "/portfolio/image4.png",
          "/portfolio/image3.png",
        ],
      },
      {
        heading: "Antonin Tron — ATLEIN",
        copy:
          "Antonin Tron speaks on sustainability, Extinction Rebellion, and the current state of luxury. A lover of surfing, luxury, sustainability, and Extinction Rebellion, Tron is reframing what a Paris Fashion Week designer can stand for.",
        images: [
          "/portfolio/image7.png",
          "/portfolio/image12.png",
          "/portfolio/image6.png",
        ],
      },
      {
        heading: "Women's Day 2022 — Strength & Empowerment",
        copy:
          "LVRSustainable celebrates International Women's Day 2022 — highlighting women worldwide, embracing gender equality, strength, and the act of empowering one another. Sharing the stories of women across different walks of life.",
        images: [
          "/portfolio/image2.png",
          "/portfolio/image11.png",
          "/portfolio/image13.png",
        ],
      },
    ],
  },
};
